import { gql } from '@apollo/client'

export const REDIRECT_URL_QUERY = gql`
  query entry($siteHandle: [String], $id: [QueryArgument]) {
    entry(site: $siteHandle, id: $id) {
      url
      slug
    }
  }
`;
